import React from 'react'
import { NormalAccountPage, TabularAccountPage } from './sections'
import { useScreen } from '@utils'

export const AccountsPage: React.FC = () => {
  const { isMobile } = useScreen()
  return isMobile ? <NormalAccountPage /> : <TabularAccountPage />
}
